import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { useSelector } from 'react-redux';
import { fechaHoraActualBoliviaSoloVista } from '../../util/valueCalculator';
import { addHeader, addTitles } from '../UI/TemplatePrintModals';

const CustomPrintModalProyecto = ({ show, handleClose, title1, title2, title3, title4, title5,title6,title7, total1, total2, content,content2, copia }) => {
    const [pdfUrl, setPdfUrl] = useState(null);
    const { nombre } = useSelector(state => state.sesion);
    let pasotit=0.9;
    useEffect(() => {
        if (show) {
            generatePdf();
        }
    }, [show, content]);

    const generatePdf = () => {
        // Tamaño personalizado: 11 cm de ancho x 16.5 cm de largo
        const doc = new jsPDF({
            orientation: 'portrait', // Orientación vertical
            unit: 'cm', // Unidades en centímetros
            format: [14, 22], // Tamaño personalizado
        });

        const pageWidth = doc.internal.pageSize.getWidth(); // Ancho de la hoja en cm (11 cm)
        const pageHeight = doc.internal.pageSize.getHeight(); // Alto de la hoja en cm (16.5 cm)
        
        const marginLeftRight = 0.5; // Márgenes izquierdo y derecho en cm (reducidos para ocupar más espacio)
        const marginTop = 0.5; // Margen superior en cm
        const marginBottom = 1.5; // Margen inferior en cm
        const headerHeight = 1.5; // Altura de la cabecera
   
       
        // Función para agregar la marca de agua
        const addWatermark = (doc) => {
            doc.setFontSize(24); // Tamaño de fuente más pequeño para el nuevo tamaño
            doc.setTextColor(240, 240, 240); // Color de la marca de agua
            doc.setFont("helvetica", "bold");
            doc.text("COPIA", pageWidth / 2, pageHeight / 2, {
                angle: 45,
                align: 'center'
            });
        };

        // Función para agregar el pie de página
        const addFooter = (doc) => {
            doc.setDrawColor(0, 50, 0); // Verde más oscuro
            doc.setLineWidth(0.02); // Grosor de la línea en cm
            doc.line(marginLeftRight, pageHeight - marginBottom, pageWidth - marginLeftRight, pageHeight - marginBottom);

            doc.setFontSize(8); // Tamaño de fuente más pequeño para el nuevo tamaño
            doc.setTextColor(0, 50, 0); // Verde más oscuro
            doc.setFont("times", "normal");
            doc.text('Calle La Madrid # 615 casi Esq. Junín - Contacto: (+591) 68705939 - cat.tarija@gmail.com', pageWidth / 2, pageHeight - marginBottom + 0.5, { align: 'center' });
            doc.text('Tarija - Bolivia', pageWidth / 2, pageHeight - marginBottom + 0.8, { align: 'center' });
             doc.setFontSize(5.5); 
            doc.text(
                `Impreso el: ${fechaHoraActualBoliviaSoloVista()} por: ${nombre} `,
                pageWidth - marginLeftRight,
                pageHeight - marginBottom + 1.2,
                { align: 'right' }
            );
        };

        // Validaciones: Asegurar que los valores no sean null o undefined
        const validTitle1 = title1 || '';
        const validTitle2 = title2 || '';
        const validTitle3 = title3 || '';
        const validTitle4 = title4 || '';
        const validTitle5 = title5 || '';
        const validTitle6 = title6 || '';
        const validTitle7 = title7 || '';
        
        // Incrementa pasotit si el título no está vacío
        if (validTitle3) pasotit += 0.4;
        if (validTitle4) pasotit += 0.4;
        if (validTitle5) pasotit += 0.4;
        if (validTitle6) pasotit += 0.4;
        if (validTitle7) pasotit += 0.4;
        
    
        const validTotal1 = total1 || '';
        const validTotal2 = total2 || '';

        // Inicializa el número de página
        let pageNumber = 0;



        const addTotals = (doc) => {
        const pageHeight = doc.internal.pageSize.getHeight(); // Altura de la página
        const remainingSpace = pageHeight - doc.autoTable.previous.finalY - marginBottom; // Espacio restante en la página
        const requiredSpace = 3; // Espacio necesario para los totales y firmas (ajusta según sea necesario)
    
        let startY = doc.autoTable.previous.finalY + 0.7;
        // Si no hay suficiente espacio, agrega una nueva página
        if (remainingSpace < requiredSpace) {
            pageNumber++
            doc.addPage();
            console.log("Add header totals")
            addHeader({ doc, pageNumber, headerHeight, marginLeftRight, marginTop, ...dimentionsHeader });
            startY = addTitles({ doc, titles, margins, headerHeight, ...dimentionsTitles });
            addFooter(doc);
        }
    
        // Dibujar los totales
        doc.setFontSize(10); // Tamaño de fuente para los totales
        doc.setFont("times", "bold");
        doc.setTextColor(0, 0, 0); // Texto en negro
    
        if (validTotal1) {
            doc.text(validTotal1, marginLeftRight, startY);
        }
        if (validTotal2) {
            doc.text(validTotal2, marginLeftRight, startY + 0.4);
        }
        addFirmas(doc,startY)
    
    };
    const addFirmas=(doc, finalYtable)=>{
        const pageHeight = doc.internal.pageSize.getHeight(); // Altura de la página
        const remainingSpace = pageHeight -finalYtable - marginBottom; // Espacio restante en la página
        const requiredSpace = 3; // Espacio necesario para los totales y firmas (ajusta según sea necesario)
    
        // Si no hay suficiente espacio, agrega una nueva página
        if (remainingSpace < requiredSpace) {
            pageNumber++
            doc.addPage();
            console.log("Add header firmas")
            addHeader({ doc, pageNumber, headerHeight, marginLeftRight, marginTop, ...dimentionsHeader });
            finalYtable = addTitles({ doc, titles, margins, headerHeight, ...dimentionsTitles });
            addFooter(doc);
        }
        // Añadir espacio después de los totales
        const spaceAfterTotals = finalYtable + 2.0;
    
        // Dibujar líneas para firmas
        doc.setFontSize(10); // Tamaño de fuente para las firmas
        doc.setFont("times", "normal");
        doc.setTextColor(0, 0, 0); // Texto en negro
    
        const firma1X = marginLeftRight; // Posición X de la primera línea
        const firma1Y = spaceAfterTotals + 0.5; // Posición Y de la primera línea
        doc.text("             __________________________                 __________________________", firma1X, firma1Y);
    }
        // Dibujar marca de agua en la primera página si es copia
        if (copia) {
            addWatermark(doc);
        }
        const fontSizeTitles= 11;


        // Configuración de encabezados, títulos y márgenes
        const dimentionsHeader = {
            fontSize: 9,
            imageScaleFactor: 0.8,
            textOffsetX: 0.5,
            textOffsetY: 0,
            showPageNumber: true,
            pageNumberFontSize: 8,
        };
        const dimentionsTitles = {
            fontSize1: 11,
            textOffsetY: 0.5,
            fontSize2: 10,
        };


        const titles = {validTitle1, validTitle2, validTitle3, validTitle4, validTitle5, validTitle6, validTitle7};
        const margins = {marginLeftRight, marginTop, marginBottom};
         
        if (typeof content === 'string') {
            console.log("Add header string")
            addHeader({doc, pageNumber, headerHeight, marginLeftRight, marginTop,...dimentionsHeader});
            addTitles({doc, titles, margins, headerHeight,...dimentionsTitles});
            doc.text(content, marginLeftRight, marginTop + headerHeight + 3);
            addFooter(doc);
        } else {
            const startY =  addTitles({doc, titles, margins, headerHeight, ...dimentionsTitles});
            autoTable(doc, {
                body: content,
                startY: startY, 
                margin: { top: startY, left: marginLeftRight, right: marginLeftRight, bottom: marginBottom },
                didDrawPage: function (data) {
                    pageNumber++;
                    console.log("Add header content add")
                    addHeader({doc, pageNumber, headerHeight, marginLeftRight, marginTop, ...dimentionsHeader});
                  if(pageNumber>1){ const newStartY =  addTitles({doc, titles, margins, headerHeight, ...dimentionsTitles});
                  console.log("newStartY",newStartY)
                  data.settings.startY = newStartY;
                    }
                    if (copia) addWatermark(doc);
                    addFooter(doc);
                },
                styles: {
                    fontSize: 8,
                    lineColor: [0, 0, 0],
                    lineWidth: 0,
                    cellPadding: 0.1,
                    valign: 'top',
                },
                headStyles: {
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    lineWidth: 0,
                    lineColor: [0, 0, 0],
                    fontStyle: 'bold',
                    valign: 'middle',
                    halign: 'right', // Alinear todos los títulos a la derecha
                },
                bodyStyles: {
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    lineWidth: 0,
                    lineColor: [0, 0, 0],
                    valign: 'top',
                },
                pageBreak: 'auto',
                rowPageBreak:"avoid"
            });
           // Solo agregás nueva página si es necesario
            let startTableY=doc.autoTable.previous.finalY + 0.7;;

         
           console.log("startTableY:", startTableY);
            console.log("Body:", content2.body);

            autoTable(doc, {
                head: content2.head,
                body: content2.body,
                startY: startTableY,
                margin: { top: startY, left: marginLeftRight, right: marginLeftRight, bottom: marginBottom },
                didDrawPage: function (data) {
                    console.log("Add header content2")
                    if(pageNumber>1){ 
                      addHeader({doc, pageNumber, headerHeight, marginLeftRight, marginTop, ...dimentionsHeader});
                      const newStartY =  addTitles({doc, titles, margins, headerHeight, ...dimentionsTitles});
                      console.log("newStartY",newStartY)
                      data.settings.startY = newStartY;
                      if (copia) addWatermark(doc);
                      addFooter(doc);
                    }
                    pageNumber++;
                },
                styles: {
                    fontSize: 8,
                    lineColor: [0, 0, 0],
                    lineWidth: 0,
                    cellPadding: 0.1,
                    valign: 'top',
                },
                headStyles: {
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    lineWidth: 0,
                    lineColor: [0, 0, 0],
                    fontStyle: 'bold',
                    valign: 'middle',
                    halign: 'right',
                },
                bodyStyles: {
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    lineWidth: 0,
                    lineColor: [0, 0, 0],
                    valign: 'top',
                },
                columnStyles: {
                    0: { halign: 'right', cellWidth: 0.7 },
                    1: { halign: 'left', cellWidth: 5 },
                    2: { halign: 'right', cellWidth: 0.7 },
                    3: { halign: 'right', cellWidth: 2.2 },
                    4: { halign: 'right', cellWidth: 2.2 },
                    5: { halign: 'right', cellWidth: 2.2 },
                },
                pageBreak: 'auto', // Permitir saltos automáticos de página
                rowPageBreak: 'auto', // Permitir que las filas se dividan entre páginas
                didParseCell: function (data) {
                    // Truncar contenido si es demasiado grande
                    if (data.section === 'body' && data.cell.raw && data.cell.raw.length > 100) {
                        data.cell.text = data.cell.raw.substring(0, 100) + '...';
                    }
                    if (data.section === 'head') {
                        data.cell.styles.halign = data.column.index ===1 ? 'left' : 'right';
                    }
        
                },
            });
            addFirmas(doc, doc.autoTable.previous.finalY)
        }

        const pdfBlob = doc.output('blob');
        const pdfUrl = URL.createObjectURL(pdfBlob);
        setPdfUrl(pdfUrl);
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{title1}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {pdfUrl && (
                    <iframe src={pdfUrl} width="100%" height="500px" title="Vista previa del Recibo"></iframe>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CustomPrintModalProyecto;

